import React from 'react';
import Navbar from './Navbar';
import Footer from '../Footer';

export default function PageWrapper({ children, hideNav = false, hideFooter = false }) {
  return (
    <div className="min-h-screen flex flex-col bg-slate-950">
      {!hideNav && <Navbar />}
      <main className="flex-grow pt-24">
        {children}
      </main>
      {!hideFooter && <Footer />}
    </div>
  );
}